import React from 'react';
import { WhatsAppIcon } from './Icons';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/qz1dADs31rdediUFi9XLPf/Logo.png';
export function Footer() {
  const navLinks = [{
    name: 'Nosotros',
    href: '#nosotros'
  }, {
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Eventos',
    href: '#eventos'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <footer className="bg-deep-brown text-cream pt-16 pb-8 border-t-4 border-terracotta" data-id="element-162">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-163">
        {/* Centered logo */}
        <div className="flex justify-center mb-12" data-id="element-164">
          <img src={LOGO_URL} alt="DeliSandwiches - Servicios de Lunch" className="h-24 w-auto object-contain" data-id="element-165" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-166">
          {/* Brand */}
          <div className="text-center md:text-left" data-id="element-167">
            <p className="text-cream/70 leading-relaxed max-w-xs mx-auto md:mx-0" data-id="element-168">
              Catering artesanal de elaboración propia. Fresco, cuidado y
              diseñado para que su mesa hable por usted.
            </p>
          </div>

          {/* Links */}
          <div className="text-center" data-id="element-169">
            <h4 className="font-serif text-xl mb-6 text-gold" data-id="element-170">Navegación</h4>
            <ul className="space-y-3" data-id="element-171">
              {navLinks.map(link => <li key={link.name} data-id="element-172">
                  <a href={link.href} className="text-cream/70 hover:text-white transition-colors" data-id="element-173">
                    {link.name}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div className="text-center md:text-right" data-id="element-174">
            <h4 className="font-serif text-xl mb-6 text-gold" data-id="element-175">Contacto</h4>
            <ul className="space-y-4 text-cream/70" data-id="element-176">
              <li className="flex items-center gap-2 justify-center md:justify-end" data-id="element-177">
                <a href="https://wa.me/59892014876" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-178">
                  <WhatsAppIcon className="w-5 h-5" data-id="element-179" />
                  092 014 876
                </a>
              </li>
              <li data-id="element-180">
                <p data-id="element-181">Carrasco, Montevideo</p>
              </li>
              <li data-id="element-182">
                <p data-id="element-183">
                  Lun a Vie: 9:00 – 18:00
                  <br data-id="element-184" />
                  Sáb: 9:00 – 14:00
                </p>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-cream/10 pt-8 text-center text-cream/50 text-sm" data-id="element-185">
          <p data-id="element-186">
            &copy; {new Date().getFullYear()} DeliSandwiches. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}